import { render, staticRenderFns } from "./TopBtns.vue?vue&type=template&id=07016677&scoped=true&"
import script from "./TopBtns.vue?vue&type=script&lang=js&"
export * from "./TopBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07016677",
  null
  
)

export default component.exports